import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getPackages = () => api.get("/packages").then((r) => r.data);
export const getTimeSlots = (date) => api.get(`/time-slots?date=${date}`).then((r) => r.data);
export const createBookingCheckout = (payload) =>
  api.post("/bookings/checkout", payload).then((r) => r.data);
export const getPaymentStatus = (sessionId) =>
  api.get(`/payments/status/${sessionId}`).then((r) => r.data);
export const uploadPhoto = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export const submitQuote = (payload) => api.post("/quote-requests", payload).then((r) => r.data);

export { API };
